
import React, { useEffect, useRef } from "react";
import { Container, Placeholder } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import uniqid from 'uniqid';

import ProviderTile from './ProviderTile';
import CategoryTitle from "./CategoryTitle";
import CategoryLinkImage from "./CategoryLinkImage";
import ScrollButtons from './ScrollButtons';

import './providersRow.scss';

export default function ProvidersRow({ categoryURL }) {
    const country = useSelector((state) => state.globalContent.data.country);
    const locale = useSelector((state) => state.globalContent.data.locale);
    const gameCategories = useSelector((state) => state.gameCategories.list);
    const category = gameCategories ? (gameCategories[`${categoryURL}-${country.ISOcode}`] || gameCategories[categoryURL]) : null;

    const placeholder = new Array(10).fill(null);
    const container = useRef(null);

    useEffect(() => { });

    return (
        <Container fluid="lg" className="game-row-container section-margin">

            {/* Title */}
            {/* {
                category ?
                    <>
                        <h3 className="h3 mb-3">{category.title}</h3>
                    </>
                    :
                    <Placeholder as="h3" animation="glow" className="mb-3">
                        <Placeholder xs={12} style={{ width: "170px", borderRadius: "10px" }} />
                    </Placeholder>
            } */}
            <CategoryTitle title={category?.title} />

            {/* Row */}
            {/* <div className="position-relative">
                <div className="provider-row-wrapper" ref={container}>

                    {
                        !category ? placeholder.map((game, i) => <ProviderTile game={game} key={uniqid()} />) :
                            category.providers.map(item => {

                                if (item.provider?.id) {
                                    return <ProviderTile provider={item.provider} key={uniqid()} />
                                }

                                return null;
                            })
                    }
                </div>

                <ScrollButtons container={container} centered={true} />
            </div> */}

            {/* Row */}
            <div className="position-relative">
                <div className="providers-row-wrapper" ref={container}>

                    {/* Games */}
                    {
                        category && (
                            category.providers.map((item, i) => {
                                if (item.provider?.id) {
                                    return (
                                        <CategoryLinkImage
                                            to={`/${locale}/games/game-providers/${encodeURI(item.provider.name)}`}
                                            src={item.provider.logoURL}
                                            key={`provider-row-${i}`}
                                            alt={item?.provider.name} />
                                    )
                                }

                                return null;
                            })
                        )
                    }
                </div>

                {/* Scroll */}
                <ScrollButtons container={container} />
            </div>
        </Container>
    );
}